var _path, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailSchedule = function SvgEmailSchedule(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6508 14.7593C15.0701 14.3998 15.1187 13.7685 14.7593 13.3492C14.3998 12.9299 13.7685 12.8813 13.3492 13.2407L14.6508 14.7593ZM11.7076 15.9649L12.3584 16.7242L11.7076 15.9649ZM9.21959 16.0565L8.62639 16.8616L9.21959 16.0565ZM12.3584 16.7242L14.6508 14.7593L13.3492 13.2407L11.0568 15.2057L12.3584 16.7242ZM9.81279 15.2515L1.5932 9.19494L0.406801 10.8051L8.62639 16.8616L9.81279 15.2515ZM11.0568 15.2057C10.7033 15.5086 10.1876 15.5276 9.81279 15.2515L8.62639 16.8616C9.75072 17.69 11.298 17.6331 12.3584 16.7242L11.0568 15.2057Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7H2.22727C1.81818 7.14583 1 7.7 1 8.75C1 9.8 1 16.1875 1 19.25C1 19.8333 1.24545 21 2.22727 21C3.20909 21 13 21 17.7727 21C18.1818 20.8542 19 20.3 19 19.25C19 18.2 19 15.9583 19 14.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15L2 20.5",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7071 14.2929C13.3166 13.9024 12.6834 13.9024 12.2929 14.2929C11.9024 14.6834 11.9024 15.3166 12.2929 15.7071L13.7071 14.2929ZM12.2929 15.7071L17.7929 21.2071L19.2071 19.7929L13.7071 14.2929L12.2929 15.7071Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5V6L19 7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-schedule.616cc8fb731af74e47eb02711ebaa4aa.svg";